// extracted by mini-css-extract-plugin
export default {"container":"style_container__8WQ5o","inliine_content":"style_inliine_content__7rK2G","swiper":"style_swiper__Fd5Px","swiper_slide":"style_swiper_slide__5AJLl"};